module.exports = __webpack_public_path__ + "img/help_register@3x.b0a35ded.png";